import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-529b22da"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-signin" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "h3 mb-3 fw-normal" }, "RateRange Edit", -1))
const _hoisted_3 = { class: "form-floating" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "floatingInput" }, "Start Range", -1))
const _hoisted_5 = { class: "form-floating" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "floatingInput" }, "End Range", -1))
const _hoisted_7 = { class: "form-floating" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "floatingInput" }, "Range Price", -1))
const _hoisted_9 = { class: "form-floating" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "Fixed" }, "Fixed", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "Relative" }, "Relative", -1))
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "floatingInput" }, "Rate Type", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "w-100 btn btn-lg btn-primary",
  type: "submit"
}, "Submit", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("form", {
      onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => ($setup.submit && $setup.submit(...args)), ["prevent"]))
    }, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.data.start_range) = $event)),
          type: "text",
          class: "form-control",
          placeholder: "Start Range",
          required: ""
        }, null, 512), [
          [_vModelText, $setup.data.start_range]
        ]),
        _hoisted_4
      ]),
      _createElementVNode("div", _hoisted_5, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.data.end_range) = $event)),
          class: "form-control",
          placeholder: "End Range",
          required: ""
        }, null, 512), [
          [_vModelText, $setup.data.end_range]
        ]),
        _hoisted_6
      ]),
      _createElementVNode("div", _hoisted_7, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.data.range_price) = $event)),
          class: "form-control",
          placeholder: "Range Price",
          required: ""
        }, null, 512), [
          [_vModelText, $setup.data.range_price]
        ]),
        _hoisted_8
      ]),
      _createElementVNode("div", _hoisted_9, [
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.data.rate_price_type) = $event)),
          class: "form-control",
          required: ""
        }, _hoisted_12, 512), [
          [_vModelSelect, $setup.data.rate_price_type]
        ]),
        _hoisted_13
      ]),
      _hoisted_14
    ], 32)
  ]))
}